// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"Label_helpIcon__21okH","label":"Label_label__1_sLF","tooltip":"Label_tooltip__3_sY6","help":"Label_help__2Fsyn"};